import { apiClient } from './client';

/**
 * Get feedbacks (Admin/Teacher/Mentor, tenant-scoped), one page at a time.
 *
 * Filters are applied by the server so paging stays honest: `courseIds` (comma-separated
 * course ids), `rating` (exact star), `search` (review text and reviewer name), `courseId`,
 * `status`. Sort with `sortBy` (createdAt | rating | helpfulCount) and `sortOrder` (asc | desc).
 * `limit` is 1-100.
 *
 * `summary` covers every review in the course scope, not just this page and ignoring the
 * rating and search filters, so a rating overview can be drawn from it.
 *
 * @param {{ page?, limit?, status?, courseId?, courseIds?, rating?, search?, sortBy?, sortOrder? }} params
 * @returns {Promise<{
 *   items: Array,
 *   meta: { total, page, limit, totalPages },
 *   summary?: { averageRating, totalReviews, ratingDistribution: Record<number, number> },
 * }>}
 */
export async function getFeedbacksAdmin(params = {}) {
  const { data } = await apiClient.get('/feedbacks/admin', { params });
  return data;
}
